import React from "react";
import styles from "./PayGoGenericView.module.scss";
import ButtonSmallIcon from "../../../../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon";


export interface PayGoGenericViewProps {
  createdBy?: string;
  createdAt?: string;
  userFor?: string;
  description?: string;
  userNameForRender?: () => JSX.Element;
  stationNameRender?: () => JSX.Element;
  organizationNameRender?: () => JSX.Element;
  onClickOrganization?: () => void;
  onClickStation?: () => void;
  onClickUser?: () => void;
  createdWith? : () => JSX.Element;
  connecterNameRender?: () => JSX.Element;
  createdByRender?: () => JSX.Element;
  pricePerKWh?: number;
  currency?: string;
  onClickPayGoOriginal?: () => void;
  paygoType?: "CREDIT_PAYGO" | "CHARGE_PAYGO" | string;
  nonce?: number;
}

export default function PayGoGenericView({
  createdAt,
  createdBy,
  createdWith,
  userFor,
  description,
  userNameForRender,
  stationNameRender,
  organizationNameRender,
  onClickOrganization,
  onClickStation,
  onClickUser,
  connecterNameRender,
  createdByRender,
  pricePerKWh,
  currency = "FCFA -",
  onClickPayGoOriginal,
  paygoType,
  nonce
 
}: PayGoGenericViewProps) {
  return (
    <>
      <div className={[styles["container"]].join(" ")}>
        {userNameForRender && (
          <ButtonSmallIcon
            label="Pour"
            valueRender={userNameForRender}
            iconType={"profil"}
            onClick={onClickUser}
          />
        )}
        {stationNameRender && (
          <ButtonSmallIcon
            label="Station"
            iconType={"electricStation"}
            valueRender={stationNameRender}
            onClick={onClickStation}
          />
        )}
        {onClickPayGoOriginal && (
          <ButtonSmallIcon
            label="Voir le PayGo original"
            iconType={"link-crooked"}
            onClick={onClickPayGoOriginal}
          />
        )}

        <ButtonSmallIcon
          label="Créé le"
          valueText={createdAt}
          iconType={"time"}
        />
        {onClickOrganization && (
          <ButtonSmallIcon
            label="Orgnanisation"
            iconType={"building"}
            valueRender={organizationNameRender}
            onClick={onClickOrganization}
          />
        )}

        {connecterNameRender && (
          <ButtonSmallIcon
            label="Connecteur Slug"
            iconType={"electric-car-plug"}
            valueRender={connecterNameRender}
          />
        )}

        {createdByRender && (
          <ButtonSmallIcon
            label="Créé par"
            iconType={"profil"}
            valueRender={createdByRender}
          />
        )}

        {
          pricePerKWh !== undefined && (
            <ButtonSmallIcon
              label="Prix par kWh"
              valueText={`${pricePerKWh} ${currency}`}
              iconType={"coin"}
            />
          )
        }
                {
          paygoType && (
            <ButtonSmallIcon
              label="Type de PayGo"
              valueText={`${paygoType}`}
              iconType={"info"}
              iconSize={7}
            />
          )
        }
        {
          nonce && (
            <ButtonSmallIcon
              label="Nonce"
              valueText={nonce+""}
              iconType={"ship"}
              iconSize={12}
            />
          )
        }
      </div>
      <div style={{ height: 50 }} />
      {description && (
        <div className={styles["description-container"]}>
          <span className={styles["description-container__label"]}>
            Information complémentaire
          </span>
          <p className={styles["description-container__desc"]}>{description}</p>
        </div>
      )}
    </>
  );
}
